import { render, staticRenderFns } from "./DisplayWebsite.vue?vue&type=template&id=b8c25d6c&scoped=true"
import script from "./DisplayWebsite.vue?vue&type=script&lang=js"
export * from "./DisplayWebsite.vue?vue&type=script&lang=js"
import style0 from "./DisplayWebsite.vue?vue&type=style&index=0&id=b8c25d6c&prod&lang=css"
import style1 from "./DisplayWebsite.vue?vue&type=style&index=1&id=b8c25d6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8c25d6c",
  null
  
)

export default component.exports